export const messages = {
  register: "Regístrate",
  signUpTo: "Registrate a",
  email: "Correo electrónico",
  password: "Contraseña",
  idAffiliatemessage: "ID Afiliado",
  alreadyHaveAnAccount: "¿Ya tienes una cuenta?  ",
  dontHaveAnAccount: "¿No tienes una cuenta?  ",
  enterHere: "Entrar aquí",
  enterYourMobilePhone: "Introduzca su telefono movil",
  login: "Entrar",
  orContinueWith: "o continuar con",
  orRegisterWith: "o regístrate con",
  enterTo: "Entrar a",
  registerTo: "Regístrate a",
  affiliateCode: "Codigo Afiliado",
  registerWith: "Registrate con",
  google: "Google",
  yourPhone: "Tu teléfono",
  yourEmail: "Tu email",
  continueWith: "Continuar con",
  enterPhoneCode: "Introduzca el código enviado al teléfono",
  validatePhoneNumber: "Validar teléfono",
  emailSent: "Email de verificación enviado",
  forgotPassword: "¿Olvidaste tu contraseña?",
  showPassword: "Mostrar contraseña",
  hidePassword: "Ocultar contraseña",

  messagesRegister:
    "Confirmo que soy mayor de 18 años y que he leído los Términos del Servicio",

  errorConfirmCode: "Error al confirmar el código",
  errorExpiredCaptcha: "El captcha ha expirado. Por favor, inténtalo de nuevo.",
  errorLoginAuth: "Error al iniciar sesión, inténtelo nuevamente",
  errorPopupClosedByUser:
    "Se ha cerrado la ventana de inicio de sesión, inténtelo nuevamente",
  errorSendPhoneCode: "Error al enviar el código al celular",
  errorTryAgain: "Error, inténtelo nuevamente",
  errorUserRegistered: "Ya se encuentra registrado, por favor, inicie sesión",
  errorVerifyPhoneCode: "Error al verificar el código",
  errorInvalidEmail: "El correo electrónico es inválido",
  errorInvalidPassword: "La contraseña es inválida",
  errorInvalidPhoneNumber: "El numero de teléfono y/o contraseña son inválidos",
  errorInInvalidPhoneNumber: "Numero de teléfono inválido",
  errorIsRequired: "El campo es requerido",
  errorAgeVerification: "Debes ser mayor de 21 años para poder registrarte",
  errorInvalidCredentials: "El correo electrónico y/o contraseña son inválidas",
  errorCheckbox:
    "Debes confirmar que eres mayor de 21 años para poder registrarte",
  errorPasswordsDoNotMatch: "Las contraseñas no coinciden",

  errorInvalidOtp: "El código OTP es inválido",

  errorAccount:
    "El número de cuenta es necesario y debe tener maximo 14 caracteres",
  errorAmount: "Error al seleccionar el monto",
  errorWithdrawalRemarks:
    "DNI es requerido y debe tener mínimo 11 caracteres y máximo 14 caracteres",
  errorWithdrawalRemarksFormat: "DNI no valido",
  errorBank: "El banco es necesario",
  errorTypeAccount: "El tipo de cuenta es necesario",

  errorFirstName: "El nombre es necesario",
  errorSecondName: "El segundo nombre es necesario",
  errorLastName: "El apellido es necesario",
  errorNickname: "El apodo es necesario",
  errorPhone: "El teléfono es necesario",
  errorBirthdate: "La fecha de nacimiento es necesaria",
  errorAddress: "La dirección es necesaria",
  errorCity: "La ciudad es necesaria",
  errorCountry: "El país es necesario",
  errorFavoriteClub: "El equipo favorito es necesario",
  errorFavoriteSports: "Debes seleccionar al menos un deporte favorito",
  errorIncorrectFormatValue: "El valor ingresado es incorrecto",
  errorProhibitedWord: "El nickname contiene palabras no permitidas",
  errorNicknameFormat:
    "Nickname inválido. Usa solo letras minúsculas (a-z), números (0-9) y guiones (-), sin espacios, sin guiones al inicio/fin ni repetidos",
  errorBanckVoucher: "El banco es requerido",
  errorDateVoucher: "La fecha es requerida",
  errorIncorrectVoucher: "El número de referencia es requerido",
  errorIncorrectVoucherValue: "El valor es requerido",
  errorIncorrectVoucherFile: "El archivo es requerido",
  errorIncorrectVoucherFileSize: "El archivo debe ser menor a 5MB"

  // ,
  // aboutUs: 'Acerca de nosotros',
  // allGames: 'Todos los juegos',
  // allRightsReserved: 'Todos los derechos reservados',
  // basketball: 'Baloncesto',
  // bettingLimit: 'Limite de apuesta',
  // bettingRules: 'Reglas de apuesta',
  // bonusConditions: 'Condiciones de bono',
  // casino: 'Casino',
  // contactUs: 'Contáctanos',
  // deposits: 'Depositos',
  // disputeResolution: 'Resolución de disputas',
  // doYouNeedHelp: '¿Necesitas ayuda?',
  //
  // esports: 'Esports',
  // faqs: 'Preguntas frecuentes',
  // favorites: 'Favoritos',
  // followUs: 'Síguenos',
  // forgotYourPassword: '¿Se te olvidó la contraseña?',
  // hockey: 'Hockey',
  // home: 'Inicio',
  // kycPolicies: 'Políticas de KYC',
  // liveEvents: 'Eventos en vivo',
  // moneyLaundering: 'Lavado de dinero',
  // ourSections: 'Nuestras secciones',
  // overview: 'Información General',
  // popularEvents: 'Eventos populares',
  // popularLeagues: 'Ligas populares',
  // profile: 'Perfil',
  // promotions: 'Promociones',
  // recommended: 'Recomendados',
  // registerWith: 'Regístrate con',
  // responsibleGaming: 'Juego responsable',
  // securityAndPrivacy: 'Seguridad & privacidad',
  // signUp: 'Registrarse',
  // soccer: 'Futbol',
  // sports: 'Deportes',
  // suggestedForYou: 'Sugeridos para ti',
  // support: 'Soporte',
  // tennis: 'Tenis',
  // termsAndConditions: 'Términos & condiciones',
  // tournaments: 'Torneos',
  // volleyball: 'Voley',
  // withdrawals: 'Retiros',
  // workWithUs: 'Trabaja con Nosotros',
}

export const signinTexts = {
  title: "Iniciar sesión",
  description: "¿Necesitas una cuenta?",
  signUp: "Crear cuenta",
  emailPlaceholder: "Correo electrónico",
  passwordPlaceholder: "Contraseña",
  showPassword: "Mostrar contraseña",
  hidePassword: "Ocultar contraseña",
  rememberMe: "Recuérdame",
  forgotPassword: "¿Olvidaste tu contraseña?",
  submit: "Iniciar sesión",
  submitting: "Iniciando sesión",
  orContinueWith: "O continuar con",
  google: "Google"
} as const

export const signupTexts = {
  title: "Crear cuenta",
  description: "Crea una cuenta para continuar",
  alreadyHaveAccount: "¿Ya tienes una cuenta?",
  signIn: "Iniciar sesión",
  usernamePlaceholder: "Ingresa un nombre de usuario único",
  emailPlaceholder: "Correo electrónico",
  passwordPlaceholder: "Contraseña",
  showPassword: "Mostrar contraseña",
  hidePassword: "Ocultar contraseña",
  passwordStrength: {
    weak: "Débil",
    medium: "Regular",
    strong: "Fuerte"
  },
  referralPlaceholder: "Código de referido / Promocional (Opcional)",
  referralInputPlaceholder: "Código",
  acceptedTerms: "Acepto y estoy de acuerdo con los",
  termsLink: "Términos y Condiciones",
  ageVerification: "Confirmo que soy mayor de 21 años",
  legalDisclaimerPrefix: "Acepto y estoy de acuerdo con todos los",
  legalDisclaimerSuffix: ", y tengo más de 18 años.",
  submit: "Crear cuenta",
  submitting: "Creando cuenta",
  orContinueWith: "O continuar con",
  google: "Google",
  errorUsername: "El nombre de usuario es necesario",
  errorAcceptedTerms: "Debes aceptar los Términos y Condiciones",
  errorDisposableEmail:
    "No se permiten correos electrónicos temporales o desechables",
  errorInvalidEmail: "Correo electrónico inválido",
  errorEmailRegistered: "Correo electrónico ya registrado",
  otp: {
    title: "Verifica tu correo",
    description: "Enviamos un código a",
    description2: ".",
    codeDescription: "Ingresa el código de 6 dígitos",
    placeholder: "Código de 6 dígitos",
    digitPlaceholder: "0",
    resendCode: "¿No recibiste el código?",
    resend: "Reenviar código",
    sending: "Enviando…",
    verifying: "Verificando…",
    sendError: "No se pudo enviar el código",
    invalid: "Código inválido"
  }
} as const
